var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-select-control-search"},[_c('SearchInput',{staticClass:"tree-select-control-search__input",attrs:{"value":_vm.value,"icon":_vm.iconSearch,"emit-input-on-change":false},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }